import ScrollToTop from "core/buttons/scroll-buttons/ScrollToTop";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { Table } from "core/table/Table";
import { Typography } from "core/typography/Typography";
import { getFormattedDate } from "utils/functions";
import { getEntityName } from "utils/helper";
import { ENTITY_TABLE_NAME } from "constants/constants";

const billingClientBySlug = ({
  list,
  clients,
  lang,
  userScope,
  namesByFilters,
}) => {
  const header = [
    {
      label: {
        key: "client_id",
        value: <FormattedMessage id="client" defaultMessage={"Client"} />,
      },
      icon: "user",
      minWidth: "22.3%",
    },
    {
      label: {
        key: "establishment_date",
        value: <FormattedMessage id="start" defaultMessage={"Début"} />,
      },
      icon: "calendar",
      minWidth: "7.9%",
    },
    {
      label: {
        key: "establishment_date_end",
        value: <FormattedMessage id="end" defaultMessage={"Fin"} />,
      },
      icon: "calendar",
      minWidth: "7.9%",
    },
  ];

  const getFormattedList = () =>
    list.map((elm) => {
      const clientSlug = clients?.find(
        (client) => client?.id === elm?.client_id
      )?.slug;
      const clientName = getEntityName(elm?.client_id, namesByFilters);

      return {
        client_id: clientSlug ? (
          <Link to={`/${userScope}/client/${clientSlug}`}>{clientName}</Link>
        ) : (
          clientName
        ),

        establishment_date: getFormattedDate(elm?.establishment_date, lang),
        establishment_date_end: getFormattedDate(
          elm?.establishment_date_end,
          lang
        ),
      };
    });

  return (
    <div className="subcontracting-company">
      <Typography
        className="title-3 violet text-uppercase"
        type="h2"
        label={<FormattedMessage id="clients" defaultMessage="Clients" />}
      />
      <Table
        entity={ENTITY_TABLE_NAME.BILLING_CLIENT}
        header={header}
        content={getFormattedList() || []}
        minWidth="100%"
      />
      <ScrollToTop />
    </div>
  );
};

export default billingClientBySlug;
